import React from 'react'
import { View } from 'react-native'

import { styles } from './Card.Styles'

const Card = ({ theme, style, children }) => {
  return <View style={{ ...styles.card(theme), ...style }}>{children}</View>
}

export default Card
